module.exports = __webpack_public_path__ + "static/media/footer_orbit.57d5e08a.svg";